module.exports = __webpack_public_path__ + "img/client9.56127b71.png";